import { useEffect } from 'react';
import { TRACKING_IDS_PAGE_LABELS, useGaTracking } from '@ids/appshell';

const usePageTracking = (pageType: TRACKING_IDS_PAGE_LABELS) => {
    const { trackPageView } = useGaTracking();

    useEffect(() => {
        trackPageView({ pageType });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageType]);
};

export default usePageTracking;
